import React from 'react';
import { NavLink } from 'react-router-dom';
import Section from './Section.jsx';
import { connect } from 'react-redux';
import SimpleAlert from './SimpleAlert.jsx';

class InterviewSimulator extends React.Component {
  constructor() {
    super();
    this.state = {
      playing: false,
      mobileModal: false,
    }
  }
  tryToPlay() {
    if (this.props.isMobile) {
      this.setState({ mobileModal: true });
    } else {
      this.setState({ playing: true });
    }
  }
  closeModal() {
    this.setState({ mobileModal: false });
  }
  render() {
    return (
      <Section>
        {
          !this.state.playing &&
          <React.Fragment>
            <h1>INTERVIEW SIMULATOR</h1>
            <div className="pBox">
              <p>This is an interview simulator that allows you to run through common interview questions with me without having to talk to me.</p>
              <p>It's designed to play like the point and click adventure games created by Sierra Online in the 80's and 90's.</p>
              <p>If you raise your cursor to the top of the play screen, you will see a menu of actions you can perform, or you can cycle through them by right-clicking.</p>
              <p>Please give the game a few moments to load assets after pressing play.</p>
              <button onClick={() => this.tryToPlay()}>PLAY</button>
            </div>
            <div className="colorBox"></div>
          </React.Fragment>
        }
        {
          this.state.playing &&
          <iframe src="https://interviewsimulator.gorah.site"></iframe>
        }
        {
          this.state.mobileModal &&
          <SimpleAlert mainText="Sorry!" subText="Not on mobile." onClose={() => this.closeModal()}/>
        }
      </Section>
    )
  }
}


const mapStateToProps = (state, newProps) => {
  return {
    isMobile: state.environment.isMobile
  }
}

export default connect(mapStateToProps)(InterviewSimulator);
